import { getAuth } from "firebase/auth";
import { patientTable } from "../../helpers/tables";
import { queryMany, queryOne } from "./all";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getFirestore,
  updateDoc,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { db } from "../../helpers/firebase";

const table = patientTable;

const clientModel = {
  getOneById: async (id) => {
    const data = await queryOne({ table, id });
    return data;
  },
  getMany: async (...args) => {
    const data = await queryMany({
      table,
      conditions: [...args],
    });
    return data;
  },
  getByEmail: async (email) => {
    const data = await queryMany({
      table,
      conditions: [["email", "==", email]],
    });
    return data.length > 0 ? data[0] : null;
  },
  create: async (props) => {
    const user = getAuth().currentUser;
    if (!user) throw new Error("User not logged in");

    const ref = await addDoc(collection(db, table), {
      ...props,
      createdAt: new Date(),
    });

    const doc = await queryOne({ table, id: ref.id });
    if (!doc) throw new Error("Client not created");
    return doc;
  },
  update: async (id, data) => {
    const clientRef = doc(getFirestore(), "clients", id);
    await updateDoc(clientRef, {
      ...data,
      updatedAt: new Date(),
    });
    return await queryOne({ table: "clients", id });
  },
  delete: async (id) => {
    const user = getAuth().currentUser;
    if (!user) throw new Error("User not logged in");

    await deleteDoc(doc(getFirestore(), table, id));
  },

  async getByAuthorizedUserId(userId) {
    const clientsRef = collection(db, "clients");
    const q = query(
      clientsRef,
      where("authorizedUserIds", "array-contains", userId)
    );
    const snap = await getDocs(q);
    if (!snap.empty) {
      const doc = snap.docs[0];
      return { id: doc.id, ...doc.data() };
    }
    return null;
  },
};

export default clientModel;
